import * as React from 'react';
import { AsyncLoader } from '../../Common/AsyncLoader';
import { VideoTile } from '../../CategoryIndex/CategoryTiles/VideoTile';
import { TileIndex } from '../../Common/TileIndex';
import {
  Advert,
  SearchQuery,
  SearchResult,
  SearchResultItem
} from '../../../models';
import './style.css';

export interface SearchResultsProps {
  advertSlotOne?: Array<Advert>;
  advertSlotTwo?: Array<Advert>;
  error: boolean;
  loading: boolean;
  pageUrl: string;
  query: SearchQuery;
  searchResult?: SearchResult;
}

export interface SearchResultsState {
  /* empty*/
}

class SearchResultsTileIndex extends TileIndex<SearchResultItem> {}

export class SearchResults extends React.Component<
  SearchResultsProps,
  SearchResultsState
> {
  render() {
    const {
      advertSlotOne,
      advertSlotTwo,
      error,
      loading,
      pageUrl
    } = this.props;

    const resultItems = this.getSortedResults();

    return (
      <SearchResultsTileIndex
        items={resultItems}
        getTile={this.getSearchResultTile}
        advertSlotOne={advertSlotOne}
        advertSlotTwo={advertSlotTwo}
      >
        <AsyncLoader
          className={
            'search-results-loader' +
            (resultItems.length ? ' search-result-loader--overlay' : '')
          }
          error={error}
          loading={loading}
          pageUrl={pageUrl}
        >
          {this.getResultsMessage()}
        </AsyncLoader>
      </SearchResultsTileIndex>
    );
  }

  /**
   * Sorts by number of matched tags (most matching tags first), and then
   * sub-sorts based on alphabetic comparison of the names of the matched tags.
   */
  private getSortedResults = (): Array<SearchResultItem> => {
    const { searchResult } = this.props;

    if (!searchResult) {
      return [];
    }

    return searchResult.results
      .slice()
      .sort(
        (
          { matchingTags, video },
          { matchingTags: matchingTagsB, video: videoB }
        ) => {
          const matchedTagsDiff = matchingTagsB.length - matchingTags.length;

          if (matchedTagsDiff !== 0) {
            return matchedTagsDiff;
          }

          return matchingTags.reduce((comparisonResult, matchingTag, index) => {
            if (comparisonResult !== 0) {
              return comparisonResult;
            }

            const matchingTagB = matchingTagsB[index];

            const tagNameComparison = matchingTag.name.localeCompare(
              matchingTagB.name
            );

            if (tagNameComparison !== 0) {
              return tagNameComparison;
            }

            return (video.name || '').localeCompare(videoB.name || '');
          }, 0);
        }
      );
  };

  private getSearchResultTile(result: SearchResultItem): JSX.Element {
    const { matchingTags, video } = result;

    return (
      <VideoTile
        key={`${video.id}-${video.name}`}
        video={video}
        tags={matchingTags}
      />
    );
  }

  private getResultsMessage = (): JSX.Element | null => {
    const { query, searchResult } = this.props;

    if (searchResult && searchResult.results.length) {
      return null;
    }

    if (query.isEmpty()) {
      return this.resultsMessage(
        `Use the controls above to select your search terms and find matching videos`
      );
    }

    return this.resultsMessage(
      `No matching videos found, try changing your search`
    );
  };

  private resultsMessage = (content: string): JSX.Element => {
    return <p className="search-results-message">{content}</p>;
  };
}

export default SearchResults;



// WEBPACK FOOTER //
// ./src/app/components/Search/SearchResults/index.tsx